import { render, staticRenderFns } from "./amount-dialog.vue?vue&type=template&id=33d12758&scoped=true&"
import script from "./amount-dialog.vue?vue&type=script&lang=js&"
export * from "./amount-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d12758",
  null
  
)

export default component.exports